// DS: C33C
/** Bottom section of a commission, containing related information
 *  https://zpl.io/2pvJMnN
 */ import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import classnames from 'classnames';
import { getDeviationTitle } from '../../../_helpers';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import UserLink from '../../../../User/Link';
import UserAvatar from '../../../../User/Avatar';
import Timestamp from '../../../../Timestamp';
import PriceBlock from './PriceBlock';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './PanelC33C.scss';
const PanelC33C = (_param)=>{
    var { deviation , showAuthor =true , showTimestamp =true , addLink , className  } = _param, priceProps = _object_without_properties(_param, [
        "deviation",
        "showAuthor",
        "showTimestamp",
        "addLink",
        "className"
    ]);
    var _dev_digitalAsset, _dev_digitalAsset_asset, _dev_digitalAsset1, _dev_digitalAsset_editionStats, _dev_digitalAsset2, _dev_digitalAsset_asset1, _dev_digitalAsset3, _dev_digitalAsset4, _dev_digitalAsset_editionStats1, _dev_digitalAsset5, _deviation_digitalAsset, _deviation_digitalAsset_asset;
    const hasDas = useFlag('digital_assets');
    const hasAsset = deviation.hasOwnProperty('digitalAsset');
    const dev = deviation;
    const hasPrice = hasAsset && ((dev === null || dev === void 0 ? void 0 : (_dev_digitalAsset = dev.digitalAsset) === null || _dev_digitalAsset === void 0 ? void 0 : (_dev_digitalAsset_asset = _dev_digitalAsset.asset) === null || _dev_digitalAsset_asset === void 0 ? void 0 : _dev_digitalAsset_asset.price) || ((_dev_digitalAsset1 = dev.digitalAsset) === null || _dev_digitalAsset1 === void 0 ? void 0 : (_dev_digitalAsset_editionStats = _dev_digitalAsset1.editionStats) === null || _dev_digitalAsset_editionStats === void 0 ? void 0 : _dev_digitalAsset_editionStats.lowDollarPrice));
    const canOffer = hasAsset && (dev === null || dev === void 0 ? void 0 : (_dev_digitalAsset2 = dev.digitalAsset) === null || _dev_digitalAsset2 === void 0 ? void 0 : (_dev_digitalAsset_asset1 = _dev_digitalAsset2.asset) === null || _dev_digitalAsset_asset1 === void 0 ? void 0 : _dev_digitalAsset_asset1.canOffer);
    const hasAuthor = deviation.author && showAuthor;
    const renderTitleWithLink = ()=>/*#__PURE__*/ React.createElement(DeviationLink, {
            deviation: deviation,
            className: classnames(s['title'], s['nowrap'])
        }, getDeviationTitle(deviation));
    const title = addLink ? renderTitleWithLink() : /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['title'], s['nowrap']),
        title: getDeviationTitle(deviation)
    }, getDeviationTitle(deviation));
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], className),
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, title, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: classnames(s['author-block'], hasAuthor && s['has-author'])
    }, hasAuthor && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UserAvatar, {
        size: 24,
        className: s['avatar'],
        user: deviation.author
    }), /*#__PURE__*/ React.createElement(UserLink, {
        user: deviation.author,
        className: classnames(s['userlink'], s['nowrap'])
    })), showTimestamp && /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime,
        className: classnames(s['timestamp'], s['nowrap'])
    }))), !hasDas && /*#__PURE__*/ React.createElement(PriceBlock, _extends({}, priceProps)), hasDas && !hasAsset && /*#__PURE__*/ React.createElement(PriceBlock, _extends({}, priceProps)), hasDas && hasAsset && hasPrice && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['das'], s['dollar'])
    }, (dev === null || dev === void 0 ? void 0 : (_dev_digitalAsset3 = dev.digitalAsset) === null || _dev_digitalAsset3 === void 0 ? void 0 : _dev_digitalAsset3.hasEditions) && `from $${(_dev_digitalAsset4 = dev.digitalAsset) === null || _dev_digitalAsset4 === void 0 ? void 0 : (_dev_digitalAsset_editionStats1 = _dev_digitalAsset4.editionStats) === null || _dev_digitalAsset_editionStats1 === void 0 ? void 0 : _dev_digitalAsset_editionStats1.lowDollarPrice}`, !(dev === null || dev === void 0 ? void 0 : (_dev_digitalAsset5 = dev.digitalAsset) === null || _dev_digitalAsset5 === void 0 ? void 0 : _dev_digitalAsset5.hasEditions) && `$${deviation === null || deviation === void 0 ? void 0 : (_deviation_digitalAsset = deviation.digitalAsset) === null || _deviation_digitalAsset === void 0 ? void 0 : (_deviation_digitalAsset_asset = _deviation_digitalAsset.asset) === null || _deviation_digitalAsset_asset === void 0 ? void 0 : _deviation_digitalAsset_asset.dollarPrice}`), hasDas && hasAsset && canOffer && /*#__PURE__*/ React.createElement("div", {
        className: s['das']
    }, /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation
    }, "MAKE OFFER")));
};
PanelC33C.displayName = 'PanelC33C';
export default PanelC33C;
